export enum DreamType {
    New,
    Existing,
    Copied
}
